import { API_ENDPOINTS } from "../constants";
import { buildListQuery } from "./agentService";
import { apiClient } from "./apiClient";

export const aiPodTenantMapping = {
  async createTenantAiPodMapping(data: any): Promise<any> {
    const url = `${API_ENDPOINTS.AI_POD_TENANT.CREATE}`;
    const result = await apiClient.post<any>(url, data, {
      authenticate: true,
    });
    return (result as any).data ?? (result as unknown as any);
  },

  async listTenantAiPodMapping(params: any): Promise<any> {
    const query = buildListQuery(params);
    const url = query
      ? `${API_ENDPOINTS.AI_POD_TENANT.LIST}?${query}`
      : API_ENDPOINTS.AI_POD_TENANT.LIST;
    const result = await apiClient.get<any>(url, {
      authenticate: true,
    });
    return (result as any).data ?? (result as unknown as any);
  },

  async listTenantMappingFromAiPod(payload: { aiPodId: string }): Promise<any> {
    const url = API_ENDPOINTS.AI_POD_TENANT.LIST_TENANTS;
    const result = await apiClient.post<any>(url, payload, {
      authenticate: true,
    });
    return (result as any).data ?? (result as unknown as any);
  },
};
